import { useEffect, useState, useRef, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';
import { Image, Typography, Row, Col, Card, Radio, Space, RadioChangeEvent, Modal } from 'antd';
import generateKey from 'utils/generateKey';
import { useInterval } from 'hooks/useInterval';
import type { InputRef } from 'antd';
import { localStorageService } from 'utils/LocalStorageService';
import { PrimaryButton } from 'components';

import mobileIcon from 'assets/images/neutral-1.svg';
import emailIcon from 'assets/images/Group 3.svg';
import styled from 'styled-components';
import { getConfig } from 'configs';
import { useLoginOtp, useValidateOtp } from 'all-in-one-shared-api';
import './otp.less';
import { setErrorCodeFun } from 'utils/setErrorCodeFun/setErrorCodeFun';
import { InvalidTextMsg, ResendCaptchaSection, SubTitle } from 'pages/registration/otp-verification/styledComponents';
import { NewInput } from 'pages/life/registration/otp-verification/styledComponents';
import GoogleCaptcha from 'components/googleCaptcha';
const { Title, Text, Link } = Typography;
import { osName, osVersion } from 'react-device-detect';
import { sessionStorageService } from 'utils/SessionStorageService';
import { useKeycloakReady } from 'hooks';
import { KeycloakClient, KeycloakTokenParsed } from '@react-keycloak/keycloak-ts';
const RESEND_COUNTDOWN_PERIOD = 60;

const config = getConfig(process.env.REACT_APP_ENVIRONMENT ?? 'mock');

interface LocationState {
  loginId: string;
  mobile?: string[];
  email?: string[];
  password: string;
  from: string;
  accountType: string;
}

type Newkey = KeycloakClient & {
  tokenParsed?: KeycloakTokenParsed & {
    ilClientKey?: string;
    ebClientKey?: string;
  };
};

const ResponsiveContainer = styled.div`
  padding-left: 40px;
  padding-right: 40px;

  @media (max-width: 768px) {
    padding-left: 0;
    padding-right: 0;
  }
`;
export const MfaOtp = (): JSX.Element => {
  const [otpArray, setOtpArray] = useState('');
  const [isAllowEdit, setIsAllowEdit] = useState(false);
  const { keycloak, initialized } = useKeycloakReady();
  const newKeycloak = keycloak as Newkey;
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [errorMsg, setErrorMsg] = useState<string | null>(null);
  const [errorStash, setErrorStash] = useState<string | null>(null);
  const [countdown, setCountdown] = useState(RESEND_COUNTDOWN_PERIOD);
  const [requestOtpCount, setRequestOtpCount] = useState(0);
  const [isShowCaptcha, setIsShowCaptcha] = useState(false);
  const location = useLocation();
  const { loginId, mobile, email, password, from, accountType } = (location.state as LocationState) ?? {};
  const [key, setKey] = useState<string>('');
  const [accountList, setAccountList] = useState<string[]>([]);
  const [otpAccount, setOtpAccount] = useState<string>('');
  const [showLaunch, setShowLaunch] = useState(false);
  const [emailTB, setEmailTb] = useState('');
  const [mobileTB, setMobileTb] = useState('');
  const [countryCodeTB, setCountryCodeTB] = useState('');
  // const {
  //   shouldFetch: AddLifePolicyFetch,
  //   data: AddLifePolicyData,
  //   error: AddLifePolicyError,
  // } = useAddLifePolicy('useAddLifePolicy', keycloak.token as string, identityNo, birthDate);
  const [loginFailCount, setLoginFailCount] = useState(0);
  const [showTips, setShowTips] = useState(false);
  const [mobileClickCounts, setMobileClickCounts] = useState<Record<string, number>>({});
  const { shouldFetch } = useLoginOtp(
    key,
    localStorageService.get('deviceId') ?? '',
    loginId ?? '',
    'LO_LOGIN',
    countryCodeTB,
    emailTB,
    mobileTB,
    {
      shouldRetryOnError: false,
      onSuccess: () => {
        shouldFetch(false);
      },
      onError: (error) => {
        shouldFetch(false);
        if (error) {
          const errorMessage = setErrorCodeFun(error.code, i18n.language);
          setErrorMsg(errorMessage ?? error.code ?? error.message);
          setErrorStash(error.code);
        }
      },
    },
  );
  const [isAdminModalOpen, setIsAdminModalOpen] = useState(false);

  const [randoms, setMathRandom] = useState(Math.random());
  const { shouldFetch: shouldValidateOtp } = useValidateOtp('validateOtp' + randoms, loginId ?? '', otpArray, {
    shouldRetryOnError: false,
    onSuccess: (validateResponse) => {
      shouldValidateOtp(false);
      if (validateResponse) {
        if (validateResponse.success) {
          startUsing();
        } else {
          //光標移入第一個輸入框
          if (digit1InputRef.current) {
            digit1InputRef.current.focus();
          } else {
            console.error('digit1InputRef.current is null');
          }
          const errorMessage = setErrorCodeFun(validateResponse.message, i18n.language);
          setErrorMsg(errorMessage ?? validateResponse.message);
          setErrorStash(validateResponse.message);

          setOtpArray('');
        }
      }
    },
    onError: (error) => {
      if (error) {
        setOtpArray('');
        shouldValidateOtp(false);
        const errorMessage = setErrorCodeFun(error.code, i18n.language);
        setErrorMsg(errorMessage ?? error.code ?? error.message);
        setErrorStash(error.code);
      }
    },
  });

  useInterval(
    () => {
      setCountdown(countdown - 1);
    },
    countdown >= 0 ? 1000 : null,
  );
  const digit1InputRef = useRef<InputRef>(null);
  const sendOtpCode = () => {
    setRequestOtpCount(0);
    setErrorStash(null);
    if (otpAccount.indexOf('@') != -1) setEmailTb(otpAccount);
    else {
      const [firstPart, secondPart] = otpAccount.split(/ (.+)/);
      setMobileTb(secondPart.replace(/\s+/g, ''));
      setCountryCodeTB(firstPart);
      setEmailTb('');
      // 记录手机号点击次数
      setMobileClickCounts((prev) => ({
        ...prev,
        [otpAccount]: (prev[otpAccount] || 0) + 1,
      }));
    }
    setIsAllowEdit(false);
    setShowLaunch(false);
    setCountdown(RESEND_COUNTDOWN_PERIOD);
    setKey(generateKey());
    shouldFetch(true);
    // setErrorMsg('life.register.resendOtp');
  };
  const handleResendOtp = () => {
    // 判断是否为手机号且点击次数大于等于1
    if (otpAccount.indexOf('@') == -1) {
      const currentMobileClickCount = mobileClickCounts[otpAccount] || 0;
      if (currentMobileClickCount >= 1) {
        setShowTips(true);
      } else {
        setShowTips(false);
      }
    } else {
      setShowTips(false);
    }

    if (requestOtpCount < 3) {
      setCountdown(RESEND_COUNTDOWN_PERIOD);
    }
    setErrorStash(null);
    console.log('onPressResend()->');
    if (otpAccount.indexOf('@') != -1) setEmailTb(otpAccount);
    else {
      const [firstPart, secondPart] = otpAccount.split(/ (.+)/);
      setMobileTb(secondPart.replace(/\s+/g, ''));
      setCountryCodeTB(firstPart);
      setEmailTb('');
      // 记录手机号点击次数
      setMobileClickCounts((prev) => ({
        ...prev,
        [otpAccount]: (prev[otpAccount] || 0) + 1,
      }));
    }
    setOtpArray('');
    setErrorMsg('life.register.resendOtp');
    if (digit1InputRef.current) {
      digit1InputRef.current.focus();
    }
    setRequestOtpCount((prev) => {
      if (prev + 1 >= 2) {
        if (!accountList.some((item) => mobile?.includes(item))) {
          setAccountList((prevList) => {
            const toAdd = mobile ?? [];
            const merged = [...prevList];
            toAdd.forEach((m) => {
              if (!merged.includes(m)) merged.push(m);
            });
            return merged;
          });
          if (email && email.length > 0 && mobile && mobile.length > 0) {
            setIsAllowEdit(true);
            setShowLaunch(true);
            setErrorMsg(null);
          }
        }
      }
      return prev + 1 >= 2 ? 0 : prev + 1;
    });
    setKey(generateKey());
    shouldFetch(true);
  };
  useEffect(() => {
    if (requestOtpCount >= 3) {
      setIsShowCaptcha(true);
    }
  }, [requestOtpCount, setIsShowCaptcha]);
  useEffect(() => {
    if (email && email.length > 0) {
      setAccountList([...email]);
      setOtpAccount(email[0]);
      if (email.length == 1) {
        setEmailTb(email[0]);
        setKey(generateKey());
        shouldFetch(true);
        setIsAllowEdit(false);
        setShowLaunch(false);
      } else {
        setIsAllowEdit(true);
        setShowLaunch(true);
      }
      return;
    } else if ((!email || email?.length == 0) && mobile && mobile.length > 0) {
      setAccountList([...mobile]);
      setOtpAccount(mobile[0]);
      if (mobile.length == 1) {
        const [firstPart, secondPart] = mobile[0].split(/ (.+)/);
        setMobileTb(secondPart.replace(/\s+/g, ''));
        setCountryCodeTB(firstPart);
        setKey(generateKey());
        shouldFetch(true);
        setIsAllowEdit(false);
        setShowLaunch(false);
      } else {
        setIsAllowEdit(true);
        setShowLaunch(true);
      }
      return;
    }
  }, [email, mobile, shouldFetch]);
  const startUsing = () => {
    if (!initialized) return;

    keycloak
      .login({
        username: loginId,
        password: password,
        device: osName,
        deviceVersion: osVersion,
        deviceId: localStorageService.get('deviceId'),
        loginMethod: 'LO_LOGIN',
        loginPlatform: 'WEB',
      })
      .then(() => {
        // sessionStorageService.set('genbravoSessionFlag', new Date().getTime().toString());
        if (keycloak.authenticated) {
          // 直接获取解析后的 token 信息
          const latestTokenParsed = newKeycloak.tokenParsed;

          const target = from?.includes('eob')
            ? from
            : latestTokenParsed && latestTokenParsed?.ebClientKey != '' // 使用最新的 tokenParsed
            ? '/home'
            : '/LIHome';
          sessionStorageService.set('genbravoSessionFlag', new Date().getTime().toString());
          navigate(target, { replace: true });
        }
        return;
      })
      .catch(() => {
        // Please handle error of login in the keycloak.onAuthError
      })
      .finally(() => {
        // setLoading(false);
      });
  };
  const ERROR_UNKNOWN = 'unknown_error';
  const INVALID_GRANT = 'invalid_grant';
  keycloak.onAuthError = (error) => {
    setLoginFailCount((count) => count + 1);
    setErrorStash(null);
    if (error.error === 'auth.admin.password.expired') {
      setIsAdminModalOpen(true);
      return;
    }
    if (error?.error === ERROR_UNKNOWN) {
      if (loginFailCount < 2) {
        startUsing();
        return;
      } else {
        navigate('/ChangeRequestError', {
          replace: true,
          state: {
            defaultTo: '/login',
            defaultLabel: t('common.error.retry'),
          },
        });
      }
    } else setErrorMsg(error?.error);

    if (error?.error === INVALID_GRANT) {
      setErrorMsg('auth.login.invalidGrant');
    }
  };
  const handleVerifyOtp = useCallback(() => {
    setErrorStash(null);
    if (!/\d{6}/.test(otpArray)) {
      setErrorMsg('smsOtpVerification.code-not-found');
      return;
    }
    setMathRandom(Math.random());
    shouldValidateOtp(true);
  }, [otpArray, setErrorMsg, shouldValidateOtp]);
  useEffect(() => {
    if (otpArray.length === 6) {
      handleVerifyOtp();
    }
  }, [otpArray, handleVerifyOtp]);
  useEffect(() => {
    if (errorStash && errorStash == 'smsOtpVerification.retry-limit-exceeded') {
      setIsAllowEdit(true);
      setCountdown(RESEND_COUNTDOWN_PERIOD);
    }
  }, [errorStash]);
  useEffect(() => {
    if (errorStash) {
      const errorMessage = setErrorCodeFun(errorStash, i18n.language);
      setErrorMsg(errorMessage);
    }
  }, [errorStash, i18n.language]);
  useEffect(() => {
    if (countdown === 0) {
      setIsAllowEdit(false);
      setErrorMsg(null);
      setErrorStash(null);

      // if (requestOtpCount >= 2) {
      //   if (!accountList.some((item) => mobile?.includes(item))) {
      //     setAccountList((prev) => [...prev, ...(mobile ?? [])]);
      //     setShowLaunch(true);
      //     setErrorMsg(null);
      //   }
      // }
    }
    // eslint-disable-next-line
  }, [countdown]);

  const onCaptchaSuccess = () => {
    setIsShowCaptcha(false);
  };

  const onCaptchaError = () => {
    setErrorStash(null);
    setErrorMsg('login.error.captchaDigitError');
  };
  const onOtpChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (isNaN(Number(e.target.value))) {
      return;
    }
    setOtpArray(e.target.value);
    setErrorMsg(null);
    setErrorStash(null);
  };
  function maskPart(part: string, minLength: number) {
    if (part.length <= minLength) {
      return part;
    }
    return part.charAt(0) + '*'.repeat(part.length - 2) + part.slice(-1);
  }
  function maskEmail(email: string) {
    if (!email) return '';
    // const [username, domain] = email.split('@');
    // const domainList = domain.split('.');
    // const maskedUsername = username.charAt(0) + '*'.repeat(username.length - 2) + username.slice(-1);
    // if (domainList.length > 0) {
    //   const maskedDomain = domainList[0].charAt(0) + '*'.repeat(domainList[0].length - 2) + domainList[0].slice(-1);
    //   if (domainList.length > 2) {
    //     return maskedUsername + '@' + maskedDomain + '.' + domainList[1] + '.' + domainList[2];
    //   } else {
    //     return maskedUsername + '@' + maskedDomain + '.' + domainList[1];
    //   }
    // }
    if (!email) return '';
    const [username, domain] = email.split('@');
    const domainList = domain.split('.');

    // 掩码用户名
    const maskedUsername = maskPart(username, 2);

    // 掩码域名
    const maskedDomain = domainList
      .map((part, index) => {
        if (index == 0) {
          // 跳过顶级域名
          return maskPart(part, 2);
        }
        return part;
      })
      .join('.');

    return maskedUsername + '@' + maskedDomain;
  }
  function maskPhoneNumber(phone: string) {
    if (!phone) return '';
    let phoneNumber = phone;
    if (phone.indexOf(' ') != -1) {
      phoneNumber = phone.split(/ (.+)/)[1].replace(/\s+/g, '');
    }
    const visibleDigits = 2;
    const startDigits = phoneNumber.substring(0, visibleDigits);
    const endDigits = phoneNumber.substring(phoneNumber.length - 2);

    const maskedPart = '*'.repeat(phoneNumber.length - visibleDigits - 2);

    return phone.indexOf(' ') != -1
      ? phone.split(/ (.+)/)[0] + ' ' + startDigits + maskedPart + endDigits
      : startDigits + maskedPart + endDigits;
  }
  const accountChange = (e: RadioChangeEvent) => {
    setOtpAccount(e.target.value);
  };
  const handleAdminChangeNow = () => {
    setIsAdminModalOpen(false);
    navigate('/update-password', {
      replace: true,
      state: { username: loginId },
    });
  };
  return (
    <ResponsiveContainer>
      <Typography.Title
        level={3}
        style={{ fontSize: '33px', fontFamily: 'Roboto400', color: '#20252b', fontWeight: '400' }}
      >
        {t('login.forgetIdOtpTitle')}
      </Typography.Title>
      <div
        className="register_otp_wrapper"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          backgroundColor: 'white',
          padding: '20px',
        }}
      >
        <Card style={{ border: 0, width: '100%', maxWidth: '400px' }}>
          <Row justify="center" gutter={[16, { xs: 8, sm: 16, md: 24 }]}>
            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              <Title level={3} style={{ marginTop: '30px', fontSize: '26px', color: '#20252B' }}>
                {t('smsOtpVerification.screenTitle')}
              </Title>
            </Col>
            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              <Title level={3} style={{ fontSize: '20px', color: 'red' }}>
                {accountType.toLocaleLowerCase() == 'eb'
                  ? otpAccount.indexOf('@') == -1 && showTips
                    ? t('sms.mfaOtpEb')
                    : t('smsOtpVerification.contactExpEb')
                  : otpAccount.indexOf('@') == -1 && showTips
                  ? t('sms.mfaOtpLife')
                  : t('smsOtpVerification.contactExpLife')}
              </Title>
            </Col>
            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              <Image
                height="176px"
                className="img_container"
                src={otpAccount.indexOf('@') != -1 ? emailIcon : mobileIcon}
                preview={false}
              />
            </Col>
            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              <SubTitle
                style={{ display: 'inline-block', textAlign: 'center', fontSize: '20px', fontFamily: 'Roboto400' }}
              >
                {otpAccount.indexOf('@') != -1
                  ? t('smsOtpVerification.emailScreenSubtitle')
                  : t('smsOtpVerification.mobileScreenSubtitle')}
                <br />
                {/* {email ? maskEmail(email) : mobile ? countryCode + '  ' + maskPhoneNumber(mobile) : null} */}

                <Radio.Group
                  onChange={accountChange}
                  value={otpAccount}
                  style={{ textAlign: 'left', fontSize: '20px', fontFamily: 'Roboto400' }}
                >
                  <Space direction="vertical" style={{ gap: 0 }}>
                    {accountList.length > 0 && accountList.length == 1
                      ? accountList[0].indexOf('@') != -1
                        ? maskEmail(accountList[0])
                        : accountList[0].split(/ (.+)/)[0] + '  ' + maskPhoneNumber(accountList[0].split(/ (.+)/)[1])
                      : accountList.map((item) => (
                          <Radio value={item} key={item} style={{ fontSize: '20px', fontFamily: 'Roboto400' }}>
                            {item.indexOf('@') != -1
                              ? maskEmail(item)
                              : item.split(/ (.+)/)[0] + '  ' + maskPhoneNumber(item.split(/ (.+)/)[1])}
                          </Radio>
                        ))}
                  </Space>
                </Radio.Group>
              </SubTitle>
            </Col>

            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              <NewInput
                maxLength={6}
                value={otpArray}
                onChange={onOtpChange}
                className="single-digit-input"
                autoFocus
                ref={digit1InputRef}
                disabled={isAllowEdit}
              />
            </Col>
            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              {errorMsg && (
                <InvalidTextMsg type="danger" style={{ marginLeft: 0 }}>
                  {t(errorMsg)}
                </InvalidTextMsg>
              )}
            </Col>

            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              <ResendCaptchaSection>
                {isShowCaptcha ? (
                  <GoogleCaptcha
                    hl={i18n.language}
                    sitekey={config.captchaSiteKey}
                    onChange={onCaptchaSuccess}
                    onError={onCaptchaError}
                    onExpired={onCaptchaError}
                  />
                ) : (
                  <>
                    {showLaunch ? (
                      <Link
                        onClick={sendOtpCode}
                        style={{
                          fontSize: '17px',
                          fontFamily: 'Roboto400',
                          color: '#752127',
                        }}
                      >
                        {t('smsOtpVerification.launch')}
                      </Link>
                    ) : (
                      <>
                        <Link
                          onClick={countdown > 0 ? (e) => e.preventDefault() : handleResendOtp}
                          style={{
                            fontSize: '17px',
                            fontFamily: 'Roboto400',
                            pointerEvents: countdown > 0 ? 'none' : 'auto',
                            color: countdown > 0 ? 'gray' : '#752127', // 设置禁用时颜色为灰色
                          }}
                        >
                          {t('smsOtpVerification.resend')}
                        </Link>
                        {countdown >= 0 && (
                          <Text type="secondary" style={{ color: '#20252B', fontSize: '17px', marginTop: 20 }}>
                            {t('smsOtpVerification.resendCountdownText', {
                              second: countdown,
                            })}
                          </Text>
                        )}
                      </>
                    )}
                  </>
                )}
              </ResendCaptchaSection>
            </Col>

            <Link
              onClick={() => {
                navigate('/login', {
                  replace: true,
                  // state: {
                  //   password: '111',
                  // },
                });
              }}
              style={{
                fontSize: '17px',
                fontFamily: 'Roboto400',
                marginLeft: 4,
                marginRight: 4,
                color: '#C21B17',
                textDecoration: 'underline',
              }}
            >
              {t('common.cancel')}
            </Link>
          </Row>
        </Card>
      </div>
      <Modal
        open={isAdminModalOpen}
        closable={false}
        title={t('admin.password.expired.title')}
        footer={
          <PrimaryButton onClick={() => handleAdminChangeNow()}>{t('admin.password.expired.changeNow')}</PrimaryButton>
        }
      >
        <Trans i18nKey="admin.password.expired.message"></Trans>
      </Modal>
    </ResponsiveContainer>
  );
};
